module.exports = __webpack_public_path__ + "static/media/coment.c419c8bb.svg";